;(function (angular) {
  'use strict'
  angular
    .module('kilo.common.directives')
    .directive('exactMatchValidation', ExactMatchDirective)

  function ExactMatchDirective () {
    return {
      restrict: 'A',
      scope: {exactMatchValidation: '@'},
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        if (scope.exactMatchValidation) {
          /**
           * $validators.confirmation - provide a modal which request to type exactly a string in the input to validate
           *
           * @param  {String} modelValue the value to match
           * @param  {String} viewValue  the value entered by the user
           * @return {Boolean} - return true if both String are equal
           */
          ctrl.$validators.confirmation = function (modelValue, viewValue) {
            return viewValue && viewValue.toLowerCase() === scope.exactMatchValidation.toLowerCase()
          }
        }
      }
    }
  }
})(window.angular)
